import { RefDate, DateInput, Button } from "@tblabs/truffle";
import { Box } from "./Box";
import moment from "moment";


export class DateInputWithIcon extends Box
{
    constructor(date: RefDate, dataTestId?: string)
    {
        const input = new DateInput(date)
            .Class("product__rental-date-input")
            .Attribute("min", new Date().toISOString().split("T")[0])
            .Attribute("data-testid", dataTestId);

        super("product__rental-date-field", [
            input,
            new Button("-", () => { }).Class("quantity-control__button").PositionAbsolute().Top(0.5, "rem").Left(0.5, "rem")
                .OnClick(() => date.value = moment(date.value).subtract(1, "day").toDate()),
            new Button("+", () => { }).Class("quantity-control__button").PositionAbsolute().Top(0.5, "rem").Right(0.5, "rem")
                .OnClick(() => date.value = moment(date.value).add(1, "day").toDate()),
        ]);

        this.Width(190)
    }
}
